/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('UserEventRelationContactListDtoTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		EventRelationContactFactory,
		UserEventRelationContactListDtoSearchFactory
	) {
		$scope.eventRelationContactList = [];
		$scope.predicate = 'id';
		$scope.ascending = false;
		$scope.paging = {};
		$scope.paging.page = 1;
		$scope.totalCountIsKnownAtTheMoment = false;

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeEventRelationContact)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeEventRelationContact);
		} else {
			$scope.pageSize = 20;

			$rootScope.pageSizeEventRelationContact = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go('user-eventrelationcontact.new', {
				mappedBy: $scope.mappedBy,
				mappedById: $scope.mappedById,
				mappedByDisplayValue: $scope.mappedByDisplayValue,
			});
		};

		$scope.getEventRelationContactList = function() {
			UserEventRelationContactListDtoSearchFactory.query(
				{
					eventId: angular.isDefined($scope.eventId) ? $scope.eventId : null,
					relationId: angular.isDefined($scope.relationId) ? $scope.relationId : null,
					salesStatus: angular.isDefined($scope.salesStatusId) ? $scope.salesStatusId : null,

					page: $scope.paging.page - 1,
					size: $scope.pageSize,
					sort: [$scope.predicate + ',' + ($scope.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.eventRelationContactList = result.items;
				}
			);
		};
		$scope.loadAll = function() {
			$scope.getEventRelationContactList();
		};

		$scope.loadPage = function() {
			$scope.loadAll();
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.predicate === itemName) {
				if ($scope.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});
